import { render } from "./XlsxWorksheet.vue?vue&type=template&id=0875acf8&scoped=true"
import script from "./XlsxWorksheet.vue?vue&type=script&lang=ts"
export * from "./XlsxWorksheet.vue?vue&type=script&lang=ts"

import "./XlsxWorksheet.vue?vue&type=style&index=0&id=0875acf8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0875acf8"

export default script